import { render, staticRenderFns } from "./PasswordResetBox.vue?vue&type=template&id=5387762b&scoped=true"
import script from "./PasswordResetBox.vue?vue&type=script&lang=js"
export * from "./PasswordResetBox.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetBox.vue?vue&type=style&index=0&id=5387762b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5387762b",
  null
  
)

export default component.exports